import { SeoRenderer } from "../../../common/helpers/seo";

import loadable from "./loadable";

export default {
    component: loadable,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({ title: allMessage["studentDashboard.title"], allMessage, lang });
    },
};
